/* Convivium — il riquadro che dice "aggiunto al carrello", uno per tutto il sito.
 *
 * Prima di questo file la stessa cosa era scritta tre volte: in
 * marketplace-page.js, in mp-card-add.js e in produttori.js. Tre copie della
 * stessa funzione, due fogli di stile con lo stesso riquadro, due elementi con
 * due id diversi. Funzionavano uguale per caso: bastava cambiare il messaggio in
 * un posto e scordarsi gli altri due perche' il sito cominciasse a rispondere in
 * tre modi diversi.
 *
 * E la pagina prodotto non partecipava affatto. Li' il tema Horizon fa volare
 * l'immagine del prodotto dentro l'icona del carrello e non scrive niente,
 * quindi chi comprava dalla scheda vedeva una cosa e chi comprava da una card ne
 * vedeva un'altra.
 *
 * Adesso il riquadro e' uno e vale ovunque:
 *
 *   Convivium.toast(messaggio)          lo chiamano i nostri gestori delle card
 *   cart:update da product-form         lo intercettiamo qui, per la scheda prodotto
 *
 * Il volo dell'immagine viene nascosto da cv-carrello.css: e' bello, ma parla
 * per immagini e non dice cosa e' successo, e su una griglia di dodici card
 * diventa confusione. Il riquadro invece funziona su ogni pagina senza
 * condizioni, dice a parole cos'e' entrato nel carrello, e chi non vede lo sente
 * annunciato dal lettore di schermo.
 */

(function () {
  'use strict';

  var DURATA = 3000;
  var timer = null;

  function elemento() {
    var el = document.getElementById('cv-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cv-toast';
      el.className = 'cv-toast';
      // role e aria-live servono a chi naviga col lettore di schermo: senza,
      // per lui il carrello si riempie in silenzio.
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  }

  function toast(messaggio, errore) {
    var el = elemento();
    // "Prodotto aggiunto al carrello" diventa "Tajarin nel carrello" quando si sa
    // quale prodotto e' appena stato aggiunto: lo segna cv-contatore al clic.
    var u = window.Convivium && window.Convivium.ultimo;
    if (!errore && messaggio === 'Prodotto aggiunto al carrello' && u && Date.now() - u.quando < 8000) {
      messaggio = u.nome + ' nel carrello';
    }
    if (timer) clearTimeout(timer);
    el.textContent = messaggio;
    el.classList.toggle('cv-toast--errore', !!errore);
    el.classList.add('cv-toast--visibile');
    timer = setTimeout(function () {
      el.classList.remove('cv-toast--visibile', 'cv-toast--errore');
    }, DURATA);
  }

  window.Convivium = window.Convivium || {};
  window.Convivium.toast = toast;

  /* La scheda prodotto.
   *
   * Il tema annuncia ogni movimento del carrello con lo stesso evento,
   * `cart:update`: un'aggiunta e un cambio di quantita' nel cassetto arrivano
   * qui identici. Se il riquadro comparisse a ogni evento apparirebbe anche
   * quando uno TOGLIE qualcosa, e direbbe una bugia.
   *
   * A distinguerli e' `data.source`, che il form della scheda prodotto riempie
   * con 'product-form-component'. Da li' passano la scheda, la barra che segue
   * lo scorrimento e la finestrella di aggiunta rapida, cioe' tutti i posti dove
   * il tema aggiunge davvero qualcosa.
   *
   * I nostri gestori delle card lanciano lo stesso evento ma senza quel campo,
   * e chiamano `Convivium.toast` per conto loro: cosi' non escono due riquadri
   * per un clic solo. */
  document.addEventListener('cart:update', function (e) {
    var d = (e && e.detail) || {};
    var dati = d.data || {};
    if (dati.source !== 'product-form-component') return;
    if (dati.didError) return;
    toast('Prodotto aggiunto al carrello');
  });
})();
